__turbopack_context__.v({
  "container": "navbar-module__6qiM_q__container",
  "cta": "navbar-module__6qiM_q__cta",
  "hamburger": "navbar-module__6qiM_q__hamburger",
  "hamburgerOpen": "navbar-module__6qiM_q__hamburgerOpen",
  "hamburgerScrolled": "navbar-module__6qiM_q__hamburgerScrolled",
  "link": "navbar-module__6qiM_q__link",
  "links": "navbar-module__6qiM_q__links",
  "logo": "navbar-module__6qiM_q__logo",
  "menuIsOpen": "navbar-module__6qiM_q__menuIsOpen",
  "mobileCta": "navbar-module__6qiM_q__mobileCta",
  "mobileLangBtn": "navbar-module__6qiM_q__mobileLangBtn",
  "mobileLink": "navbar-module__6qiM_q__mobileLink",
  "mobileLinks": "navbar-module__6qiM_q__mobileLinks",
  "mobileMenu": "navbar-module__6qiM_q__mobileMenu",
  "mobileMenuOpen": "navbar-module__6qiM_q__mobileMenuOpen",
  "mobileRight": "navbar-module__6qiM_q__mobileRight",
  "navbar": "navbar-module__6qiM_q__navbar",
  "scrolled": "navbar-module__6qiM_q__scrolled",
});
